module.exports = __webpack_public_path__ + "static/media/image_2.7ac5977e.png";